/* eslint-disable react/function-component-definition */
import React, { useMemo } from 'react';

import { ReactComponent as AEDCurrency } from '../assets/icons/aed-currency.svg';
import { ReactComponent as EnergicCaffeeActive } from '../assets/icons/amenities/caffee-active.svg';
import { ReactComponent as EnergicCarwashActive } from '../assets/icons/amenities/carwash-active.svg';
import { ReactComponent as EnergicGasStationActive } from '../assets/icons/amenities/gas-station-active.svg';
import { ReactComponent as EnergicLockerActive } from '../assets/icons/amenities/locker-active.svg';
import { ReactComponent as EnergicLoungeActive } from '../assets/icons/amenities/lounge-active.svg';
import { ReactComponent as EnergicRelaxingActive } from '../assets/icons/amenities/relaxing-active.svg';
import { ReactComponent as EnergicRestaurantActive } from '../assets/icons/amenities/restaurant-active.svg';
import { ReactComponent as EnergicRestroomActive } from '../assets/icons/amenities/restroom-active.svg';
import { ReactComponent as EnergicShoppingActive } from '../assets/icons/amenities/shopping-active.svg';
import { ReactComponent as EnergicWifiActive } from '../assets/icons/amenities/wifi-active.svg';
import { ReactComponent as EnergicWorkshopActive } from '../assets/icons/amenities/workshop-active.svg';
import { ReactComponent as EnergicCurrentPrice } from '../assets/icons/current-price-sae.svg';
import { ReactComponent as VoltieCurrentPrice } from '../assets/icons/currentPrice.svg';
import { ReactComponent as EnergicActiveClockIcon } from '../assets/icons/dashboard/clock-icon.svg';
import { ReactComponent as EnergicActiveConnectorIcon } from '../assets/icons/dashboard/connector-icon.svg';
import { ReactComponent as EnergicActiveDeviceIcon } from '../assets/icons/dashboard/device-icon.svg';
import { ReactComponent as EnergiceDashboardCardIcon1 } from '../assets/icons/dashboard/map-energy-icon.svg';
import { ReactComponent as EnergiceDashboardCardIcon2 } from '../assets/icons/dashboard/map-revenue-icon.svg';
import { ReactComponent as EnergiceDashboardCardIcon3 } from '../assets/icons/dashboard/map-user-icon.svg';
import energicStatinLocator from '../assets/icons/dashboard/station-locator.svg';
import { ReactComponent as EnergicContactIcon } from '../assets/icons/profile/contact.svg';
import { ReactComponent as EnergicFacilityIcon } from '../assets/icons/profile/facility.svg';
import { ReactComponent as EnergicCurrency } from '../assets/icons/profile/sar.svg';
import { ReactComponent as EnergicWithdrawalHistoryIcon } from '../assets/icons/profile/withdrawalHistory.svg';
import { ReactComponent as EnergicWalletIcon } from '../assets/icons/wallet-minus.svg';
import energicCardsCar from '../assets/images/dashboard/cards-car.png';
import energicChargingDevice from '../assets/images/dashboard/energic-device.png';
import EnergicEmptyCharger from '../assets/images/empty-charge-point.png';
import energicDarkThemeLogo from '../assets/images/ev-logo-dark.png';
import energicLogo from '../assets/images/ev-logo.png';
import energicQRLogo from '../assets/images/qr-logo.png';
import energicReigsterBanner from '../assets/images/register/register-banner.png';
import energicChargeDeviceImage from '../assets/images/schedule/device-image.png';
import energicEmptyChargeDeviceImage from '../assets/images/schedule/empty-charge-point.png';
import { ReactComponent as VoltieCaffeeActive } from '../assets/voltie/icons/amenities/caffee-active.svg';
import { ReactComponent as VoltieCarwashActive } from '../assets/voltie/icons/amenities/carwash-active.svg';
import { ReactComponent as VoltieGasStationActive } from '../assets/voltie/icons/amenities/gas-station-active.svg';
import { ReactComponent as VoltieLockerActive } from '../assets/voltie/icons/amenities/locker-active.svg';
import { ReactComponent as VoltieLoungeActive } from '../assets/voltie/icons/amenities/lounge-active.svg';
import { ReactComponent as VoltieRelaxingActive } from '../assets/voltie/icons/amenities/relaxing-active.svg';
import { ReactComponent as VoltieRestaurantActive } from '../assets/voltie/icons/amenities/restaurant-active.svg';
import { ReactComponent as VoltieRestroomActive } from '../assets/voltie/icons/amenities/restroom-active.svg';
import { ReactComponent as VoltieShoppingActive } from '../assets/voltie/icons/amenities/shopping-active.svg';
import { ReactComponent as VoltieWifiActive } from '../assets/voltie/icons/amenities/wifi-active.svg';
import { ReactComponent as VoltieWorkshopActive } from '../assets/voltie/icons/amenities/workshop-active.svg';
import { ReactComponent as VoltieActiveClockIcon } from '../assets/voltie/icons/dashboard/clock-icon.svg';
import { ReactComponent as VoltieActiveConnectorIcon } from '../assets/voltie/icons/dashboard/connector-icon.svg';
import { ReactComponent as VoltieActiveDeviceIcon } from '../assets/voltie/icons/dashboard/device-icon.svg';
import { ReactComponent as VoltieDashboardCardIcon1 } from '../assets/voltie/icons/dashboard/map-energy-icon.svg';
import { ReactComponent as VoltieDashboardCardIcon2 } from '../assets/voltie/icons/dashboard/map-revenue-icon.svg';
import { ReactComponent as VoltieDashboardCardIcon3 } from '../assets/voltie/icons/dashboard/map-user-icon.svg';
import voltieStatinLocator from '../assets/voltie/icons/dashboard/station-locator.svg';
import { ReactComponent as VoltieContactIcon } from '../assets/voltie/icons/profile/contact.svg';
import { ReactComponent as VoltieCurrency } from '../assets/voltie/icons/profile/currency-icon.svg';
import { ReactComponent as VoltieFacilityIcon } from '../assets/voltie/icons/profile/facility.svg';
import { ReactComponent as VoltieWalletIcon } from '../assets/voltie/icons/profile/wallet-minus.svg';
import { ReactComponent as VoltieWithdrawalHistoryIcon } from '../assets/voltie/icons/profile/withdrawalHistory.svg';
import voltieCardsCar from '../assets/voltie/images/dashboard/cards-car.png';
import voltieChargingDevice from '../assets/voltie/images/dashboard/volti-device.png';
import VoltieEmptyCharger from '../assets/voltie/images/empty-charge-point.png';
import voltieRegisterBanner from '../assets/voltie/images/login/login-banner.png';
import voltieQRLogo from '../assets/voltie/images/qr-logo.png';
import voltieChargeDeviceImage from '../assets/voltie/images/schedule/device-image.png';
import voltieEmptyChargeDeviceImage from '../assets/voltie/images/schedule/empty-charge-point.png';
import voltieLogo from '../assets/voltie/images/voltie-logo.png';
// eslint-disable-next-line import/no-cycle
import { useBranding } from '../contexts/BrandingContext';
import brandingService from '../utils/api/brandingService';

import { branding } from './enum'; // Enum for brand keys

type BrandingType = 'energic' | 'voltie' | 'custom';

const brandInEnvironment = (process.env.REACT_APP_BRANDING as BrandingType) || 'energic';

export const currentBranding: BrandingType = brandInEnvironment;

/**
 * Standard img tag for remote URLs
 */
const RemoteImage: React.FC<any> = ({ src, alt = 'logo', ...properties }) =>
  React.createElement('img', {
    src,
    alt,
    style: { maxWidth: '100%', height: 'auto', display: 'block' },
    ...properties,
  });

/**
 * Map of currency codes to their respective SVG component.
 */
export const currencyIcons: Record<string, React.FC<any>> = {
  SAR: EnergicCurrency,
  USD: VoltieCurrency,
  AED: AEDCurrency,
};

/**
 * Gets the currency icon component for a given currency code.
 * @param {string} [currencyCode] - The currency code.
 * @returns {React.FC<any>} The React component for the currency icon.
 */
export const getCurrencyIcon = (currencyCode?: string): React.FC<any> => {
  const code = (currencyCode || '').toUpperCase();
  return currencyIcons[code] || currencyIcons.SAR;
};

/**
 * Component that dynamically renders the currency icon based on branding context or localStorage cache.
 * @param {any} properties - React properties.
 * @returns {React.ReactElement} The rendered currency icon element.
 */
export function DynamicCurrencyIcon(properties: any) {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const IconComponent = getCurrencyIcon(brandText.currency);
  return React.createElement(IconComponent, properties);
}

// Define image and icon mappings for each brand
const brandMapping = {
  [branding.ENERGIC]: {
    images: {
      logo: energicLogo,
      qrLogo: energicQRLogo,
      logoDarkTheme: energicDarkThemeLogo,
      loginBanner: energicReigsterBanner,
      cardsCar: energicCardsCar,
      deviceWithTwoConnectors: energicChargeDeviceImage,
      deviceWithoutConnectors: energicEmptyChargeDeviceImage,
      chargingDevice: energicChargingDevice,
      emptyChargerImage: EnergicEmptyCharger,
    },
    icons: {
      stationLocator: energicStatinLocator,
      mapEnergyIcon: EnergiceDashboardCardIcon1,
      mapRevenueIcon: EnergiceDashboardCardIcon2,
      mapUserIcon: EnergiceDashboardCardIcon3,
      facilityIcon: EnergicFacilityIcon,
      contactIcon: EnergicContactIcon,
      withdrawalHistoryIcon: EnergicWithdrawalHistoryIcon,
      dollarCurrency: EnergicCurrency,
      currencyIcon: DynamicCurrencyIcon,
      CaffeeActive: EnergicCaffeeActive,
      CarwashActive: EnergicCarwashActive,
      GasStationActive: EnergicGasStationActive,
      LockerActive: EnergicLockerActive,
      LoungeActive: EnergicLoungeActive,
      RelaxingActive: EnergicRelaxingActive,
      RestaurantActive: EnergicRestaurantActive,
      RestroomActive: EnergicRestroomActive,
      ShoppingActive: EnergicShoppingActive,
      WifiActive: EnergicWifiActive,
      WorkshopActive: EnergicWorkshopActive,
      ActiveClockIcon: EnergicActiveClockIcon,
      ActiveDeviceIcon: EnergicActiveDeviceIcon,
      ActiveConnectorIcon: EnergicActiveConnectorIcon,
      WalletIcon: EnergicWalletIcon,
      CurrentPriceIcon: EnergicCurrentPrice,
    },
    meta: {
      title: 'Energic Control – Effortless EV Charging Station Management',
      description:
        'Take control of your EV charging stations with Energic Control. This powerful web app offers seamless management, dynamic pricing, real-time monitoring, and smart scheduling to maximize efficiency and performance. Perfect for EV facility owners looking to streamline operations.',
      footerText: false,
    },
    colors: {
      primary: '#00A79D',
      reportChart: '#00A79D1A',
      reportChart1: '#4ABDFB',
    },
    message: {
      toastMessage: 'Account not verified! Please contact energic admin.',
    },
    text: {
      currency: 'SAR',
    },
  },
  [branding.VOLTIE]: {
    images: {
      logo: voltieLogo,
      qrLogo: voltieQRLogo,
      logoDarkTheme: voltieLogo,
      loginBanner: voltieRegisterBanner,
      cardsCar: voltieCardsCar,
      deviceWithTwoConnectors: voltieChargeDeviceImage,
      deviceWithoutConnectors: voltieEmptyChargeDeviceImage,
      chargingDevice: voltieChargingDevice,
      emptyChargerImage: VoltieEmptyCharger,
    },
    icons: {
      stationLocator: voltieStatinLocator,
      mapEnergyIcon: VoltieDashboardCardIcon1,
      mapRevenueIcon: VoltieDashboardCardIcon2,
      mapUserIcon: VoltieDashboardCardIcon3,
      facilityIcon: VoltieFacilityIcon,
      contactIcon: VoltieContactIcon,
      withdrawalHistoryIcon: VoltieWithdrawalHistoryIcon,
      dollarCurrency: VoltieCurrency,
      currencyIcon: DynamicCurrencyIcon,
      CaffeeActive: VoltieCaffeeActive,
      CarwashActive: VoltieCarwashActive,
      GasStationActive: VoltieGasStationActive,
      LockerActive: VoltieLockerActive,
      LoungeActive: VoltieLoungeActive,
      RelaxingActive: VoltieRelaxingActive,
      RestaurantActive: VoltieRestaurantActive,
      RestroomActive: VoltieRestroomActive,
      ShoppingActive: VoltieShoppingActive,
      WifiActive: VoltieWifiActive,
      WorkshopActive: VoltieWorkshopActive,
      ActiveClockIcon: VoltieActiveClockIcon,
      ActiveDeviceIcon: VoltieActiveDeviceIcon,
      ActiveConnectorIcon: VoltieActiveConnectorIcon,
      WalletIcon: VoltieWalletIcon,
      CurrentPriceIcon: VoltieCurrentPrice,
    },
    meta: {
      title: 'Voltie Power Up – Effortless EV Charging Station Management',
      description:
        'Take control of your EV charging stations with Voltie Power Up. This powerful web app offers seamless management, dynamic pricing, real-time monitoring, and smart scheduling to maximize efficiency and performance. Perfect for EV facility owners looking to streamline operations.',
      footerText: false,
    },
    colors: {
      primary: '#39B6FF',
      reportChart: '#39B6FF1A',
    },
    message: {
      toastMessage: 'Account not verified! Please contact voltie admin.',
    },
    text: {
      currency: 'USD',
    },
  },
};

const defaultBrand = brandMapping[branding.ENERGIC];

// Initial configuration
const currentBrandValue =
  currentBranding && brandMapping[currentBranding] ? brandMapping[currentBranding] : defaultBrand;

// Export the brand-specific configurations as constants pointing to mutable objects
export const brandImage: typeof currentBrandValue.images & { logo: string; logoDarkTheme: string } =
  { ...currentBrandValue.images };
export const brandIcons: typeof currentBrandValue.icons & { LoginBanner?: React.FC<any> } = {
  ...currentBrandValue.icons,
};
export const metaValues: typeof currentBrandValue.meta = { ...currentBrandValue.meta };
export const brandColors: typeof currentBrandValue.colors = { ...currentBrandValue.colors };
export const brandMessage: typeof currentBrandValue.message = { ...currentBrandValue.message };
export const brandText: typeof currentBrandValue.text = { ...currentBrandValue.text };

/**
 * Updates the branding constants with runtime data.
 * @param {any} data - The runtime branding data.
 */
export const updateRuntimeBranding = (data: any) => {
  if (data) {
    // Update metadata
    if (data.clientName) {
      metaValues.title = data.clientName;
    }

    // Update images
    if (data.logo) {
      brandImage.logo = data.logo;
      brandImage.logoDarkTheme = data.logo;
    }

    // Update currency
    if (data.currencyCode) {
      brandText.currency = data.currencyCode;
    }

    // Update icons - Specifically the Login Banner component
    /**
     * Renders the dynamic login banner.
     * @param {any} properties - React properties.
     * @returns {React.ReactElement} The image component.
     */
    brandIcons.LoginBanner = (properties: any) =>
      React.createElement(RemoteImage, {
        src: data.logo,
        alt: data.clientName,
        ...properties,
      });

    // Update currency text
    if (data.currencyCode) {
      brandText.currency = data.currencyCode;
    }

    // Update currency icon (if available in future)
    if (data.currencyIcon) {
      /**
       * Renders the dynamic currency icon.
       * @param {any} properties - React properties.
       * @returns {React.ReactElement} The image component.
       */
      brandIcons.dollarCurrency = (properties: any) =>
        React.createElement(RemoteImage, {
          src: data.currencyIcon,
          alt: data.currencyCode || 'currency',
          ...properties,
          style: { width: 24, height: 24, display: 'inline-block', ...properties?.style },
        });
    }
  }
};

// Apply cache if available immediately
const cached = brandingService.getCachedBranding();
if (cached) {
  updateRuntimeBranding(cached);
}

export type BrandConfig = Omit<typeof currentBrandValue, 'images' | 'icons'> & {
  images: typeof currentBrandValue.images & { logo: string; logoDarkTheme: string };
  icons: typeof currentBrandValue.icons & { LoginBanner?: React.FC<any> };
};

/**
 * Hook to get the current reactive branding.
 * Recomputes whenever BrandingContext's runtime brand data changes,
 * instead of relying on mutation of the shared module-level constants.
 * @returns {BrandConfig} The current reactive brand configuration.
 */
export const useAppBranding = (): BrandConfig => {
  const { brandData } = useBranding();

  return useMemo(() => {
    let brand: BrandConfig = currentBrandValue;

    if (brandData) {
      brand = {
        ...brand,
        images: {
          ...brand.images,
          logo: brandData.logo || brand.images.logo,
          logoDarkTheme: brandData.logo || brand.images.logoDarkTheme,
        },
        icons: {
          ...brand.icons,
          /**
           * Renders the dynamic login banner.
           * @param {any} properties - React properties.
           * @returns {React.ReactElement} The image component.
           */
          LoginBanner: (properties: any) =>
            React.createElement(RemoteImage, {
              src: brandData.logo || brand.images.logo,
              alt: brandData.clientName || brand.meta.title,
              ...properties,
            }),
        },
        meta: {
          ...brand.meta,
          title: brandData.clientName || brand.meta.title,
          description: brandData.clientName || brand.meta.description,
          footerText: brandData.footer || brand.meta.footerText,
        },
        text: {
          ...brand.text,
          currency: brandData.currencyCode || brand.text.currency,
        },
      };
    }

    return brand;
  }, [brandData]);
};
